/* @flow */
import Container from 'components/Container.jsx';
import React from 'react';
import TitleHeader from 'components/TitleHeader.jsx';

import './styles/TransactionsListNuxSection.scss';

export default React.createClass({
  render() {
    return (
      <div className="TransactionsListNuxSection TransactionsListNuxSection-nux">
        <Container size="medium">
          <TitleHeader
            image={require('assets/images/payments/your-transactions-null.svg')}
            imageClassName="TransactionsListNuxSection-image"
            title="No transactions yet"
            subtext={`Your transaction history will appear here. Send money, see the activities
              shared with you, and more.`}
          />
        </Container>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/payments/components/TransactionsListNuxSection.jsx